import { handleLogin, getKindeInstance, clearIdentified } from '../auth/kindeClient';
import { showBoostModal } from './modals';
import { showShopPage } from './shop';
import { displayLoggedOutView } from './views';
import { showSettingsMenu } from './settings';
import { stopOnlinePresence } from '../services/PresenceService.js';
import { stopLeaderboardAutoRefresh } from './leaderboard.js';
import { showAppLoader, hideAppLoader } from './loader';
import { showSnordeluxeSelectModal } from './playBattle';
import { showArsenal } from './arsenal';
import { showFullLeaderboardModal } from './leaderboard';
import { initLeaguesUI } from './leagues';

function attachEventListeners() {
    const playButton = document.getElementById('playButton');
    const playBattleButton = document.getElementById('playBattleButton');
    const shopButton = document.getElementById('shopButton');
    const arsenalButton = document.getElementById('arsenalButton');
    const leaderboardButton = document.getElementById('leaderboardButton');
    const upgradeButton = document.getElementById('upgradeButton');
    const settingsActionButton = document.getElementById('settingsActionButton');
    const logoutButton = document.getElementById('logoutButton');
    const settingsButton = document.getElementById('settingsButton');

    // Add event listeners
    if (playButton) {
        playButton.addEventListener('click', async function() {
            if (playButton.disabled) return;
            console.log("Attempting to log in...");
            playButton.disabled = true;
            showAppLoader('Signing you in…', 'auth');
            try {
                await handleLogin();
            } catch (e) {
                console.error('handleLogin threw:', e);
                hideAppLoader();
                playButton.disabled = false;
            }
            // If handleLogin redirected, this code never runs.
            // If it returned synchronously (already signed in), the loader
            // will be hidden by displayLoggedInView/displayLoggedOutView.
        });
    }

    if (shopButton && shopButton.dataset.wired !== '1') {
        shopButton.dataset.wired = '1';
        shopButton.addEventListener('click', showShopPage);
    }

    if (playBattleButton && playBattleButton.dataset.wired !== '1') {
        playBattleButton.dataset.wired = '1';
        playBattleButton.addEventListener('click', showSnordeluxeSelectModal);
    }

    if (arsenalButton && arsenalButton.dataset.wired !== '1') {
        arsenalButton.dataset.wired = '1';
        arsenalButton.addEventListener('click', showArsenal);
    }

    if (leaderboardButton && leaderboardButton.dataset.wired !== '1') {
        leaderboardButton.dataset.wired = '1';
        leaderboardButton.addEventListener('click', showFullLeaderboardModal);
    }

    // Leagues button wires itself + its modal close handlers via initLeaguesUI,
    // which is idempotent so attaching it here every login is safe.
    initLeaguesUI();

    if (settingsActionButton && settingsActionButton.dataset.wired !== '1') {
        settingsActionButton.dataset.wired = '1';
        settingsActionButton.addEventListener('click', showSettingsMenu);
    }

    if (upgradeButton && upgradeButton.dataset.wired !== '1') {
        upgradeButton.dataset.wired = '1';
        upgradeButton.addEventListener('click', showBoostModal);
    }

    if (logoutButton) {
        logoutButton.addEventListener('click', async () => {
            console.log('User logging out - stopping presence tracking');
            
            // Stop online presence tracking
            stopOnlinePresence();
            
            // Stop leaderboard auto-refresh
            stopLeaderboardAutoRefresh();
            
            // Perform logout
            clearIdentified();
            const kinde = getKindeInstance();
            await kinde.logout();
            displayLoggedOutView();
        });
    }

    if (settingsButton) {
        settingsButton.addEventListener('click', showSettingsMenu);
    }
}

export { attachEventListeners };
